export enum AffiliatePlatform {
  IOS = 'ios',
  ANDROID = 'android',
}
